import React, { useRef, useMemo } from "react";
import { Box, Button, Stack } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Swiper as SwiperClass } from "swiper/swiper"; // Import Swiper type
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TestimonialCard, { Testimonial } from "./TestimonialsCard";
import {
  LiaLongArrowAltRightSolid,
  LiaLongArrowAltLeftSolid,
} from "react-icons/lia";
import { useTranslation } from "react-i18next";

import "../../styles/TestimonialsSection/TestimonialsCards.scss";
import i18n from "../../../../i18n";
import i18next from "../../../../i18n";

const Testimonials: React.FC = () => {
  const { t } = useTranslation();
  const swiperRef = useRef<SwiperClass | null>(null);

  // Memoize the testimonials list to prevent unnecessary re-renders
  const testimonialsList: Testimonial[] = useMemo(
    () => [
      {
        name: "Sreejith",
        rate: 5,
        role: t("testimonial_entrepreneur"),
        description: t("testimonial_1"),
      },
      {
        name: "Shaju",
        rate: 5,
        role: t("testimonial_business_owner"),
        description: t("testimonial_2"),
      },
      {
        name: "Sudheer",
        rate: 5,
        role: t("testimonial_business_owner"),
        description: t("testimonial_3"),
      },
      {
        name: "Anbes Asrat",
        rate: 5,
        role: t("testimonial_business_owner"),
        description: t("testimonial_4"),
      },
    ],
    [t]
  ); // Recalculate only when `t` changes

  const handlePrevClick = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNextClick = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  return (
    <div className="testimonials--cards-container">
      <Box
        sx={{
          width: { sm: "90vw", md: "100vw", xs: "90vw" },
        }}
      >
        <Swiper
          loop={true}
          key={i18n.language}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          modules={[Navigation, Autoplay]}
          onSwiper={(swiper: SwiperClass) => (swiperRef.current = swiper)}
          breakpoints={{
            0: { slidesPerView: 1 }, // Mobile - 1 card
            600: { slidesPerView: 1 }, // Small screens - 1 card
            900: { slidesPerView: 2 }, // Tablets - 2 cards
            1200: { slidesPerView: 3 }, // Laptops - 3 cards
          }}
        >
          {testimonialsList.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <TestimonialCard testimonial={testimonial} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      <Stack direction="row" justifyContent="right" sx={{ mt: 2 }}>
        <Button
          className="swipe-btn"
          variant="outlined"
          onClick={handlePrevClick}
          sx={{
            marginInline: ".5rem",
            fontFamily: i18next.language === "ar" ? "Somar" : "DM Sans",
            borderColor: "#E3E3E3",
            display: { xs: "block", sm: "block" }, // Hide on mobile
          }}
        >
          {i18n.language === "en" ? (
            <LiaLongArrowAltLeftSolid
              display={"flex"}
              size={"1.5rem"}
              color="#1B1B1B"
            />
          ) : (
            <LiaLongArrowAltLeftSolid
              display={"flex"}
              size={"1.5rem"}
              color="#1B1B1B"
              style={{ transform: "rotate(180deg)" }}
            />
          )}
        </Button>
        <Button
          variant="outlined"
          onClick={handleNextClick}
          sx={{
            borderColor: "#E3E3E3", fontFamily :i18next.language === "ar" ? "Somar" : "DM Sans",
            marginInline: ".5rem",
            display: { xs: "block", sm: "block" }, // Hide on mobile
          }}
        >
          {i18n.language === "en" ? (
            <LiaLongArrowAltRightSolid
              display={"flex"}
              size={"1.5rem"}
              color="#1B1B1B"
            />
          ) : (
            <LiaLongArrowAltRightSolid
              display={"flex"}
              size={"1.5rem"}
              color="#1B1B1B"
              style={{ transform: "rotate(180deg)" }}
            />
          )}
        </Button>
      </Stack>
    </div>
  );
};

export default Testimonials;
